import { useQuery } from '@tanstack/react-query';
import { useApiFetchJson } from '../lib/apiFetchJson';
import { AdminUsersListResponseSchema } from './admin-users.schema';

/** GET /api/admin/users under the shared ['admin', 'users'] cache key. */
export function useAdminUsers(opts: { enabled?: boolean; staleTime?: number } = {}) {
  const apiFetchJson = useApiFetchJson();
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: () => apiFetchJson(AdminUsersListResponseSchema, '/api/admin/users'),
    ...opts,
  });
}
